export const SET_NOT_SENDED_QUERY_PLUGINS = "SET_NOT_SENDED_QUERY_PLUGINS";
export const SET_NOT_SENDED_QUERY_PLUGINS_DESCRIPTION = "SET_NOT_SENDED_QUERY_PLUGINS_DESCRIPTION"
export const SET_NOT_SENDED_QUERY_PLUGINS_TABLE_OR_PIVOT = "SET_NOT_SENDED_QUERY_PLUGINS_TABLE_OR_PIVOT"

/**
 * Sets not sended plugins id
 */
export const setNotSendedQueryPlugins = contentObject => {
  return (dispatch) => {
    dispatch({
      type: SET_NOT_SENDED_QUERY_PLUGINS,
      payload: contentObject,
    });
  };
}

/*
* Sets not sended query plugins description
*/
export const setNotSendedQueryPluginsDescription = contentObject => {
  return (dispatch) => {
    dispatch({
      type: SET_NOT_SENDED_QUERY_PLUGINS_DESCRIPTION,
      payload: contentObject,
    });
  };
}

/*
* Sets not sended query plugins description
*/
export const setNotSendedQueryTableOrPivot = contentObject => {
  return (dispatch) => {
    dispatch({
      type: SET_NOT_SENDED_QUERY_PLUGINS_TABLE_OR_PIVOT,
      payload: contentObject,
    });
  };
}
